import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export default function I18nWrapper({ children }: { children: React.ReactNode }) {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        setTimeout(() => {
            const hasReloaded = sessionStorage.getItem('hasReloaded');

            if (!hasReloaded) {
                sessionStorage.setItem('hasReloaded', 'true');
                window.location.reload();
            }
        }, 200);

    }, [i18n, t]);

    return <>{children}</>;
}
